<div>
  <form [formGroup]="blogForm">
    <app-input-wrapper>
      <label>Title</label>
      <input
        formControlName="faqTitle"
        placeholder="Title"
        maxlength="200"
      />
    </app-input-wrapper>
  </form>
  <div class="flex justify-end faq_button">
    <button class="button" type="button" (click)="toggleQuestionModal(true)">
      <img src="assets/images/add.svg" alt="+" />
      Add FAQ
    </button>
  </div>

  <app-modal
    *ngIf="showQuestionModal"
    [modalTitle]="editQuestion ? 'Edit Question' : 'Add Question'"
    (closeModal)="toggleQuestionModal(false)"
  >
    <app-add-edit-question
      (onSubmit)="faqSubmit($event)"
      [editQuestion]="editQuestion"
      (onClose)="close()"
    ></app-add-edit-question
  ></app-modal>

  <ng-container *ngIf="questions.length > 0; else noQuestion">
    <app-topic-question
      (onEdit)="onEditQuestion($event)"
      (onDelete)="deleteQuestion($event)"
      [questions]="questions"
      [reset]="true"
    ></app-topic-question>
  </ng-container>
</div>
<ng-template #noQuestion></ng-template>
